import React from 'react';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/component/ds/ui/select';
import { cn } from 'src/component/ds/utils';

const ALL = '__all__';

export interface FilterSelectProps {
  /** Already-translated prefix, e.g. "Location:". */
  label: string;
  /** The applied value, or '' for all. */
  value: string;
  options: string[];
  allLabel: string;
  onValueChange: (value: string) => void;
  'aria-label'?: string;
  className?: string;
  testId?: string;
}

export function FilterSelect ({
  label,
  value,
  options,
  allLabel,
  onValueChange,
  'aria-label': ariaLabel,
  className,
  testId
}: FilterSelectProps) {
  // A persisted value can arrive before its options load, so it stays listed to show in the trigger.
  const items = value && !options.includes(value) ? [value, ...options] : options;

  return (
    <Select value={value || ALL} onValueChange={(next) => onValueChange(next === ALL ? '' : next)}>
      <SelectTrigger
        size='sm'
        aria-label={ariaLabel}
        data-testid={testId}
        className={cn('ds-shadow-xs', !value && 'ds-bg-transparent', className)}
      >
        <span className='ds-flex ds-min-w-0 ds-flex-1 ds-gap-1.5'>
          <span className='ds-shrink-0 ds-text-muted-foreground'>{label}</span>
          <span className='ds-truncate'><SelectValue /></span>
        </span>
      </SelectTrigger>
      <SelectContent align='end' className='ds-max-h-[320px]'>
        <SelectItem value={ALL}>{allLabel}</SelectItem>
        {items.map((option) => (
          <SelectItem key={option} value={option} data-testid={testId ? `${testId}-option-${option}` : undefined}>
            {option}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
